import React from 'react';
import { Box, IconButton, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/system';

interface Props {
	open: boolean;
	onClose: () => void;
	txHashes: string[];
	reasonOfRejection: string;
}

const StyledModalBox = styled(Box)({
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 500,
	maxHeight: '80vh',
	backgroundColor: '#fff',
	borderRadius: 8,
	boxShadow: '0 4px 12px rgba(0,0,0,0.16)',
	outline: 'none',
	display: 'flex',
	flexDirection: 'column',
	padding: 24,
});

const Header = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	marginBottom: 16,
});

export default function TransactionHashesModal({
	open,
	onClose,
	txHashes,
	reasonOfRejection,
}: Props) {
	return (
		<Modal open={open} onClose={onClose} style={{ zIndex: 4000 }}>
			<StyledModalBox>
				<Header>
					<Typography variant="subtitle1" fontWeight={600}>
						{`Reward Claim Result`}
					</Typography>
					<IconButton size="small" onClick={onClose}>
						<CloseIcon fontSize="small" />
					</IconButton>
				</Header>
				{!reasonOfRejection && (
					<Typography
						variant={'caption'}
						style={{ marginBottom: 10 }}
						fontWeight={600}
					>
						Txhash(s)
					</Typography>
				)}
				{reasonOfRejection && (
					<Typography variant={'caption'} style={{ marginBottom: 5 }}>
						Rejected: {reasonOfRejection}
					</Typography>
				)}
				{txHashes.map((d) => (
					<Typography variant={'caption'} style={{ marginBottom: 5 }}>
						- {d}
					</Typography>
				))}
			</StyledModalBox>
		</Modal>
	);
}
